<<!-- kol认证 -->
<template>
  <div class="fz-14 4 text-l pb-40 c-333">
    <el-row class="line-32 mt-20">
      <el-col :span="12">
        <i class="el-icon-map-location fz-20 mr-6 c-9da"></i>
        <span>寄样收货地址</span>
      </el-col>
      <el-col :span="12" class="text-r">
        <el-button type="primary" plain @click="showAdress">添加地址</el-button>
      </el-col>
    </el-row>
    <template>
      <el-table :data="tableData" stripe style="width:100%" class="mt-20">
        <el-table-column prop label="收货人">
          <template slot-scope="scope">
            <span class="b-btns" :class="scope.row.type==1?'b-ea4':'b-c1c'">默认</span>
            <span class="pl-6">{{scope.row.username}}</span>
          </template>
        </el-table-column>
        <el-table-column prop label="所在地区">
          <template slot-scope="scope">
            <span>{{scope.row.province}}</span>
            <span>{{scope.row.city}}</span>
            <span>{{scope.row.town}}</span>
          </template>
        </el-table-column>
        <el-table-column prop label="详细地址">
          <template slot-scope="scope">
            <span>{{scope.row.address}}</span>
          </template>
        </el-table-column>
        <el-table-column prop label="手机号">
          <template slot-scope="scope">
            <span>{{scope.row.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column prop label="操作">
          <template slot-scope="scope">
            <el-button size='mini' type="primary" @click="showDel(scope.row)">删除</el-button>
            <el-button size='mini'  @click="eiditAdress(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 推广帐号 -->
    <template>
      <el-row class="mt-55 line-32">
        <el-col :span="12" class="flex-al">
          <i class="el-icon-postcard fz-20 mr-6 c-9da"></i>
          <span>推广帐号认证</span>
          <div class="mynumber">
            <el-tooltip placement="right" content="请将【个人专属验证码】编辑到抖音或快手【个人简介】最后面">
              <div class="b-ea4 c-fff mynumber flex-al default">
                <span class="fz-14">个人专属验证码</span>
                <span class="jiange">|</span>
                <span class="bold fz-14">{{authentication_code}}</span>
                <i class="el-icon-question ml-4"></i>
              </div>
            </el-tooltip>
          </div>
        </el-col>
        <el-col :span="12" class="text-r">
          <el-button type="primary" plain @click="showMyvip">添加推广帐号</el-button>
        </el-col>
      </el-row>
      <template>
        <el-table :data="videolist" stripe style="width:100%" class="mt-20">
          <el-table-column prop label="平台">
            <template slot-scope="scope">
              <span>{{scope.row.video_type==1?"抖音":"快手"}}</span>
            </template>
          </el-table-column>
          <el-table-column prop label="帐号" width="240px">
            <template slot-scope="scope">
              <div class="flex-al">
                <img class="head" :src="scope.row.video_head_img">
                <div class="ml-8">
                  <div>{{scope.row.video_name}}</div>
                  <div>{{scope.row.video_type==1?"抖音号":"快手号"}}：{{scope.row.video_id}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop label="帐号信息">
            <template slot-scope="scope">
             <div> <span class="c-ea4">{{scope.row.video_fans_num}}</span>粉丝</div>
             <div> <span class="c-ea4">{{scope.row.video_zan_num}}</span>点赞</div>
             <div> <span class="c-ea4">{{scope.row.video_works_num}}</span>作品</div>
            </template>
          </el-table-column>
          <el-table-column prop label="相关微信号">
            <template slot-scope="scope">
              <span>{{scope.row.video_wechat}}</span>
            </template>
          </el-table-column>
          <el-table-column prop label="创建时间" width='150px'>
            <template slot-scope="scope">
              <span>{{scope.row.create_time}}</span>
            </template>
          </el-table-column>
          <el-table-column prop label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.video_status==1">待审核</span>
              <span v-if="scope.row.video_status==3">未通过</span>
              <span v-if="scope.row.video_status==2">通过</span>
            </template>
          </el-table-column>
          <el-table-column prop label="操作">
            <template slot-scope="scope">
              <el-button size='mini' type="primary" @click="editVideo(scope.row)" v-if="scope.row.video_status==3">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </template>
    <!-- 删除地址 -->
    <el-dialog title="确认删除该地址吗？" :close-on-click-modal='false' :visible.sync="del" width="380px" :show-close="false">
      <!-- <div class="fz-14 line-22">确认删除该地址吗？</div> -->
      <div class="fz-14 line-20">{{address}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="del = false">取 消</el-button>
        <el-button type="primary" @click="setDel">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加地址 -->
    <el-dialog :title="addresstxt" :visible.sync="add" width="556px" :close-on-click-modal='false'>
      <el-row class="line-32 fz-14">
        <el-col :span="24">
          <el-col :span="5" class="text-r">
            <span class="c-ea4">*</span>
            <span>地址信息：</span>
          </el-col>
          <el-col :span="19">
            <el-select v-model="province_id" style="width:120px;" @change="setAdress($event,1)">
              <el-option
                v-for="item in province_arr"
                :label="item.name"
                :value="item.dtid"
                :key="item.name"
              >{{item.name}}</el-option>
            </el-select>
            <el-select
              v-model="city_id"
              style="width:120px;"
              class="ml-10"
              @change="setAdress($event,2)"
            >
              <el-option
                v-for="item in city_arr"
                :label="item.name"
                :value="item.dtid"
                :key="item.name"
              >{{item.name}}</el-option>
            </el-select>
            <el-select v-model="town_id" style="width:120px;" class="ml-10">
              <el-option
                v-for="item in area_arr"
                :label="item.name"
                :value="item.dtid"
                :key="item.name"
              >{{item.name}}</el-option>
            </el-select>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 fz-14 mt-20">
        <el-col :span="24">
          <el-col :span="5" class="text-r">
            <span class="c-ea4">*</span>
            <span>详细地址：</span>
          </el-col>
          <el-col :span="19">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"
              v-model.trim="address"
              style="width:380px;min-height:30px;"
            ></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 fz-14 mt-20">
        <el-col :span="24">
          <el-col :span="5" class="text-r">
            <span class="c-ea4">*</span>
            <span>收货人姓名：</span>
          </el-col>
          <el-col :span="19">
            <el-input placeholder="长度不超过25个字符" v-model.trim="username" style="width:380px;"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 fz-14 mt-20">
        <el-col :span="24">
          <el-col :span="5" class="text-r">
            <span class="c-ea4">*</span>
            <span>手机号码：</span>
          </el-col>
          <el-col :span="18">
            <el-input
              placeholder="请输入手机号码"
              type="number"
              v-model.trim="phone"
              style="width:380px;"
              class="kucun"
            ></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 mt-10" :gutter="16">
        <el-col :span="24" :offset="5">
          <el-checkbox v-model="checked">设置为默认收货地址</el-checkbox>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="add=false">取消</el-button>
        <el-button type="primary" @click="addAddress">保存</el-button>
      </span>
      <!-- <el-row class="center mt-10">
        <el-button type="primary" size="medium" style="width:380px;" @click="addAddress">保存</el-button>
      </el-row>-->
    </el-dialog>

    <!-- 新增带货帐号 -->
    <el-dialog :title="videotitle" :visible.sync="addnum" width="500px" :close-on-click-modal='false'>
      <el-row class="line-32 fz-14">
        <el-col :span="24">
          <el-col :span="6" class="text-r">
            <span class="c-ea4">*</span>
            <span>带货平台：</span>
          </el-col>
          <el-col :span="17">
            <el-select v-model="video_type	" style="width:325px;" @change="getChange($event)">
              <el-option
                v-for="item in video"
                :label="item.name"
                :value="item.label"
                :key="item.name"
              >{{item.name}}</el-option>
            </el-select>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="fz-14 mt-20">
        <el-col :span="24" class="line-32">
          <el-col :span="6" class="text-r">
            <span class="c-ea4">*</span>
            <span>帐号id：</span>
          </el-col>
          <el-col :span="17">
            <el-input v-model.trim="video_id"></el-input>
          </el-col>
        </el-col>
        <el-col :span="24" class>
          <el-col :span="17" :offset="6">
            <div class="fz-8 line-20 c-c0c">【抖音--个人昵称下方--抖音号】/【快手--个人资料--用户id】</div>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 fz-14 mt-6">
        <el-col :span="24">
          <el-col :span="6" class="text-r">
            <span class="c-ea4">*</span>
            <span>个人名片链接：</span>
          </el-col>
          <el-col :span="17">
            <el-input v-model.trim="video_url" placeholder></el-input>
          </el-col>
        </el-col>
        <el-col :span="24" class>
          <el-col :span="17" :offset="6">
            <div class="fz-8 line-20 c-c0c">【抖音--我--更多--个人名片--复制链接】/【快手--个人主页--分享--复制链接】</div>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 fz-14 mt-6">
        <el-col :span="24">
          <el-col :span="6" class="text-r">
            <span class="c-ea4">*</span>
            <span>关联微信号：</span>
          </el-col>
          <el-col :span="17">
            <el-input v-model.trim="video_wechat" placeholder="个人真实在用的微信号"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-32 mt-10">
        <el-col :offset="6" class="flex-al">
          <el-tooltip placement="right" content="请将【个人专属验证码】编辑到抖音或快手【个人简介】最后面">
              <div class="b-ea4 c-fff mynumber flex-al default">
                <span class="fz-14">个人专属验证码</span>
                <span class="jiange">|</span>
                <span class="bold fz-14">{{authentication_code}}</span>
                <i class="el-icon-question ml-4"></i>
              </div>
            </el-tooltip>
          <span class="c-ea4 pointer ml-10" @click="goKolpross">了解认证流程</span>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addnum=false">取消</el-button>
        <el-button type="danger" @click="addVideoAccount">提交审核</el-button>
      </span>
      <!-- <el-row class="center mt-20">
        <el-button type="primary" size="medium" style="width:360px;">提交审核</el-button>
      </el-row>-->
    </el-dialog>
  </div>
</template>

<script>
import "./tool.css";
export default {
  name: "kol",
  data() {
    return {
      api: {
        get_district: "/get_district", //三级联动
        addAddress: "/home/addAddress", //添加地址
        addressList: "/home/addressList", //d达人地址列表
        deleteAddress: "/home/deleteAddress", //删除地址
        addVideoAccount: "/home/addVideoAccount", //添加抖音快手认证帐号
        videoAccountlist: "/home/videoAccountlist", //抖音快手账号列表
        updateVideoAccount: "/home/updateVideoAccount" //更新快手认证帐号
      },
      authentication_code: "", //个人专属验证码
      addresstxt: "", //弹框标题
      province_arr: [],
      city_arr: [],
      area_arr: [],
      province_id: "", //省
      city_id: "", //市
      town_id: "", //区
      address: "", //详细地址
      username: "", //收货人
      phone: "", //电话
      add: false, //新增收获地址
      asid: "", //修改条数id
      checked: false,
      del: false, //删除
      areamail: "", //省市区
      addnum: false,
      videotitle: "",
      video: [
        {
          label: 1,
          name: "抖音"
        },
        {
          label: 2,
          name: "快手"
        }
      ],
      video_type: "", //渠道 1抖音 2快手
      video_id: "", //	平台账号ID
      video_wechat: "", //相关微信
      video_url: "", //个人名牌连接
      tableData: [], //地址列表
      videolist: [], //视频列表
      vocsid: "" //视频id
    };
  },
  components: {},
  created() {
    this.addressList();
    this.videoAccountlist();
    this.authentication_code = this.$http.getAuth(
      "user_info"
    ).authentication_code;
  },
  mounted() {},
  methods: {
    addressList() {
      //地址列表
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.addressList,
        params: data
      })
        .then(res => {
          if (res.code == 1) {
            _this.tableData = res.data;
          }
        })
        .catch(err => [console.log(err)]);
    },
    getDistrict(upid, level) {
      //三级联动地址
      let _this = this;
      let data = {
        upid: upid,
        level: level
      };
      this.$http({
        method: "GET",
        url: _this.api.get_district,
        params: data
      })
        .then(res => {
          if (res.code == 1) {
            if (level == 1) {
              _this.province_arr = res.data;
              _this.add = true;
            } else if (level == 2) {
              _this.city_arr = res.data;
            } else if (level == 3) {
              _this.area_arr = res.data;
            }
          }
        })
        .catch(err => {
          _this.$message({
            message: err,
            type: "error"
          });
        });
    },
    setAdress(e, num) {
      console.log(e, num);
      if (num == 1) {
        this.city_arr = [];
        this.area_arr = [];
        this.city_id = "";
        this.town_id = "";
        this.getDistrict(e, 2);
      } else if (num == 2) {
        this.area_arr = [];
        this.town_id = "";
        this.getDistrict(e, 3);
      }
    },
    addAddress() {
      //添加默认地址
      let _this = this;
      let num = this.getData();
      let url = "";
      if (num) {
        return false;
      }
      this.getDetailed();
      let data = {
        province_id: this.province_id,
        city_id: this.city_id,
        town_id: this.town_id,
        address: this.areamail + this.address,
        username: this.username,
        phone: this.phone,
        type: this.checked ? 1 : 2,
        urid: this.$http.getAuth("user_info").urid,
        asid: this.asid
      };
      if (this.addresstxt == "新增收货地址") {
        url = "/home/addAddress";
      } else {
        url = "/home/updateAddress";
      }
      this.$http({
        method: "PUT",
        url: url,
        params: data
      })
        .then(res => {
          if ((res.code = 1)) {
            if (this.addresstxt == "新增收货地址") {
              _this.$message({
                message: "添加地址成功",
                type: "success"
              });
            } else {
              _this.$message({
                message: "修改地址成功",
                type: "success"
              });
            }

            _this.add = false;
            _this.addressList();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDetailed() {
      let _this = this;
      let address = "";
      this.province_arr.forEach(item => {
        if (item.dtid == _this.province_id) {
          address += item.name + " ";
        }
      });
      if (this.city_arr.length) {
        this.city_arr.forEach(item => {
          if (item.dtid == _this.city_id) {
            address += item.name + " ";
          }
        });
      }
      if (this.area_arr.length) {
        this.area_arr.forEach(item => {
          if (item.dtid == _this.town_id) {
            address += item.name + " ";
          }
        });
      }
      this.areamail = address;
    },
    getData() {
      //填写地址验证
      let num = "";
      if (!this.province_id) {
        this.$message({
          message: "请选择所在省",
          type: "warning"
        });
        num++;
      } else if (!this.address) {
        this.$message({
          message: "请填写详细地址",
          type: "warning"
        });
        num++;
      } else if (!this.username) {
        this.$message({
          message: "收货人姓名",
          type: "warning"
        });
        num++;
      } else if (this.username.length > 25) {
        this.$message({
          message: "收货人姓名不能超过25个字符",
          type: "warning"
        });
        num++;
      } else if (!this.phone) {
        this.$message({
          message: "请填写手机号码",
          type: "warning"
        });
        num++;
      } else if (this.phone.length<10) {
        this.$message({
          message: "请填写正确手机号码",
          type: "warning"
        });
        num++;
      } else if (!/^1[3|4|5|8|7|9][0-9]\d{4,8}$/.test(this.phone)) {
        this.$message({
          message: "请填写正确手机号码",
          type: "warning"
        });
        num++;
      }
      return num > 0 ? true : false;
    },
    setDel() {
      let _this = this;
      let data = {
        asid: this.asid
      };
      this.$http({
        method: "PUT",
        url: _this.api.deleteAddress,
        params: data
      })
        .then(res => {
          if (res.code == 1) {
            _this.$message({
              message: "删除成功",
              type: "success"
            });
            _this.del = false;
            _this.addressList();
          } else {
            _this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showDel(data) {
      this.del = true;
      this.asid = data.asid;
      this.address = data.address;
    },
    //新增地址
    showAdress() {
      this.addresstxt = "新增收货地址";
      this.restData();
      this.getDistrict(0, 1);
    },
    eiditAdress(data) {
      //修改地址
      console.log(data);
      this.restData();
      this.addresstxt = "修改收货地址";
      this.province_id = data.province_id;
      this.city_id = data.city_id;
      this.town_id = data.town_id;
      this.getDistrict(0, 1);
      this.getDistrict(data.province_id, 2);
      this.getDistrict(data.city_id, 3);
      this.address = data.address;
      this.username = data.username;
      this.phone = data.phone;
      this.asid = data.asid;
      if (data.type == 1) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    restData() {
      this.province_arr = [];
      this.city_arr = [];
      this.area_arr = [];
      this.province_id = "";
      this.city_id = "";
      this.town_id = "";
      this.address = "";
      this.username = "";
      this.phone = "";
      this.checked = false;
      this.asid = "";
      this.areamail = "";
    },
    //添加推广帐号
    showMyvip() {
      this.videotitle = "新增带货帐号";
      this.restpingtai();
      this.addnum = true;
    },
    getChange(e) {
      console.log(e);
    },
    //添加抖音快手帐号认证
    addVideoAccount() {
      let num = this.pingtai();
      if (num) {
        return false;
      }
      let url = "";
      if (this.videotitle == "新增带货帐号") {
        url = this.api.addVideoAccount;
      } else if (this.videotitle == "编辑带货帐号") {
        url = this.api.updateVideoAccount;
      }
      let _this = this;
      if(/[\u4E00-\u9FA5]/i.test(_this.video_id)){
        this.$message.error('账号id不能有中文字符');
        return
      }
      let data = {
        video_type: _this.video_type,
        video_id: _this.video_id,
        video_wechat: _this.video_wechat,
        video_url: _this.video_url,
        vocsid: _this.vocsid
      };
      this.$http({
        method: "PUT",
        url: url,
        params: data
      }).then(res => {
        if (res.code == 1) {
          if (_this.videotitle == "新增带货帐号") {
            _this.$message({
              message: "添加账号成功！",
              type: "success"
            });
          } else {
            _this.$message({
              message: "编辑账号成功！",
              type: "success"
            });
          }
          _this.videoAccountlist();
          _this.addnum = false;
        } else {
          _this.$message({
            message: res.data,
            type: "error"
          });
        }
      });
    },
    //平台列表
    videoAccountlist() {
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.videoAccountlist,
        params: data
      }).then(res => {
        if (res.code == 1) {
          let arr = res.data
          arr.forEach((item,index)=>{
            item.video_fans_num = item.video_fans_num >=10000 ? Math.floor(item.video_fans_num/1000)/10 +'万' : item.video_fans_num
          })
          _this.videolist = arr;
        } else {
          _this.$message({
            message: res.meg,
            type: "error"
          });
        }
      });
    },
    pingtai() {
      let num = "";
      if (!this.video_type) {
        this.$message({
          message: "渠道不能为空",
          type: "warning"
        });
        num++;
      } else if (!this.video_id) {
        this.$message({
          message: "平台帐号不能为空",
          type: "warning"
        });
        num++;
      } else if (!this.video_url) {
        this.$message({
          message: "个人名牌连接不能为空",
          type: "warning"
        });
        num++;
      } else if (!this.video_wechat) {
        this.$message({
          message: "相关微信不能为空",
          type: "warning"
        });
        num++;
      }
      return num > 0 ? true : false;
    },
    restpingtai() {
      this.video_type = "";
      this.video_id = "";
      this.video_url = "";
      this.video_wechat = "";
    },
    editVideo(data) {
      //编辑平台
      this.restpingtai();
      this.addnum = true;
      this.videotitle = "编辑带货帐号";
      this.video_type = data.video_type;
      this.video_id = data.video_id;
      this.video_url = data.video_url;
      this.video_wechat = data.video_wechat;
      this.vocsid = data.vocsid;
    },
    goKolpross() {
      window.open("https://xl.linkstars.com/admin/#/my/heads?type=1");
    }
  }
};
</script>
<style  scoped>
.b-btns {
  color: #fff;
  border-radius: 4px;
  padding: 0 4px;
}
.mynumber {
  height: 20px;
  border-radius: 16px;
  line-height: 20px;
  padding: 0 6px;
}
.jiange {
  padding: 0 4px;
}
.head {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>